export default __webpack_public_path__ + "maps-examples-camera-animators-1200-b7a267c5127078156d54a717ae5d3e89.png";